import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { iFullStoreState, iPerson } from '../../../shared/interfaces'
import { IMinimalPerson } from '../shared/types'

export const usePeople = (): { availablePeople: IMinimalPerson[] } => {
  const people = useSelector<iFullStoreState, { [key: string]: iPerson }>(
    (s) => s.general.people
  )

  const availablePeople: IMinimalPerson[] = useMemo(
    () => {
      const peopleArray = Object.values(people || {})

      return peopleArray
        .filter((person) => person && (person.name || person.displayName))
        .map((person) => ({
          id: person.id,
          name: person.name || '',
          displayName: person.displayName,
        }))
    },
    [people]
  )

  return {
    availablePeople,
  }
}
